/**
 * Next-class-plan modules that stay selected.
 * Keep in sync with src/utils/mandatoryNextPlanModules.js
 * and packages/shared/src/mandatoryNextPlanModules.ts.
 *
 * Catalog titles vary ("BRAINGYM EXERCISES", "RECALLING ACTIVITY",
 * "BRAIN STIMULATION ACTIVITIES - AGE 6 TO 8 YEARS"). Matching uses
 * the meaningful words, so extra words like activity/age/years do not
 * drop a required module, and lookalikes such as Color Meditation stay optional.
 */

const CANONICAL = new Set([
  'meditation',
  'brain gym',
  'brain stimulation 6 8',
  'brain stimulation 9 11',
  'brain stimulation 12 15',
  'advanced mathematics',
  'recalling',
  'non dominant hand',
  'blindfold',
]);

const FILLER = new Set([
  'activity',
  'activities',
  'age',
  'year',
  'years',
  'exercise',
  'exercises',
]);

const WORD_MAP = {
  maths: ['mathematics'],
  math: ['mathematics'],
  advance: ['advanced'],
  dominating: ['dominant'],
  hands: ['hand'],
};

const ABBREV = {
  ndh: 'non dominant hand',
};

function canonicalKey(name) {
  let s = String(name || '').toLowerCase();
  s = s.replace(/&/g, ' and ');
  s = s.replace(/[^a-z0-9]+/g, ' ');
  s = s.replace(/\s+/g, ' ').trim();
  s = s.replace(/\bbraingym\b/g, 'brain gym');
  s = s.replace(/\bblind fold\b/g, 'blindfold');
  s = s.replace(/(\d+)\s*to\s*(\d+)/g, '$1 $2');

  const tokens = [];
  for (const word of s.split(' ')) {
    if (!word || FILLER.has(word)) continue;
    const mapped = WORD_MAP[word];
    if (mapped) tokens.push(...mapped);
    else tokens.push(word);
  }
  const key = tokens.join(' ');
  return ABBREV[key] || key;
}

export function isMandatoryNextPlanModuleName(name) {
  return CANONICAL.has(canonicalKey(name));
}
